export enum TitleContentType {
	ComingSoon = 'coming-soon',
	LeavingSoon = 'leaving-soon',
}
